<template>

    <transition name="modal">
        <!-- Edit -->
        <v-modal-action-edit-condition v-if="action && showModal === 'action-edit-condition-' + action.id" :action="action" />
        <v-modal-action-edit-delay v-if="action && showModal === 'action-edit-delay-' + action.id" :action="action" />
        <v-modal-action-edit-discord v-if="action && showModal === 'action-edit-discord-' + action.id" :action="action" />
        <v-modal-action-edit-email v-if="action && showModal === 'action-edit-email-' + action.id" :action="action" />
        <v-modal-action-edit-push v-if="action && showModal === 'action-edit-push-' + action.id" :action="action" />
        <v-modal-action-edit-shoutout v-if="action && showModal === 'action-edit-shoutout-' + action.id" :action="action" />
        <v-modal-action-edit-slack v-if="action && showModal === 'action-edit-slack-' + action.id" :action="action" />
        <v-modal-action-edit-twilio v-if="action && showModal === 'action-edit-twilio-' + action.id" :action="action" />
        <v-modal-action-edit-tag v-if="action && showModal === 'action-edit-tag-' + action.id" :action="action" />
        <v-modal-action-edit-webhook v-if="action && showModal === 'action-edit-webhook-' + action.id" :action="action" />
        <v-modal-action-edit-zapier v-if="action && showModal === 'action-edit-zapier-' + action.id" :action="action" />
        <!-- Test -->
        <v-modal-action-test-email v-if="action && showModal === 'action-test-email-' + action.id" :action="action" />
        <v-modal-action-test-webhook v-if="action && showModal === 'action-test-webhook-' + action.id" :action="action" />
    </transition>

</template>

<script>

import ModalActionEditCondition from '@modals/action/ModalActionEditCondition';
import ModalActionEditDelay from '@modals/action/ModalActionEditDelay';
import ModalActionEditDiscord from '@modals/action/ModalActionEditDiscord';
import ModalActionEditEmail from '@modals/action/ModalActionEditEmail';
import ModalActionEditPush from '@modals/action/ModalActionEditPush';
import ModalActionEditShoutOut from '@modals/action/ModalActionEditShoutOut';
import ModalActionEditSlack from '@modals/action/ModalActionEditSlack';
import ModalActionEditTag from '@modals/action/ModalActionEditTag';
import ModalActionEditTwilio from '@modals/action/ModalActionEditTwilio';
import ModalActionEditWebhook from '@modals/action/ModalActionEditWebhook';
import ModalActionEditZapier from '@modals/action/ModalActionEditZapier';
import ModalActionTestEmail from '@modals/action/ModalActionTestEmail';
import ModalActionTestWebhook from '@modals/action/ModalActionTestWebhook';

export default {

    components: {
        'v-modal-action-edit-condition': ModalActionEditCondition,
        'v-modal-action-edit-delay': ModalActionEditDelay,
        'v-modal-action-edit-discord': ModalActionEditDiscord,
        'v-modal-action-edit-email': ModalActionEditEmail,
        'v-modal-action-edit-push': ModalActionEditPush,
        'v-modal-action-edit-shoutout': ModalActionEditShoutOut,
        'v-modal-action-edit-slack': ModalActionEditSlack,
        'v-modal-action-edit-tag': ModalActionEditTag,
        'v-modal-action-edit-twilio': ModalActionEditTwilio,
        'v-modal-action-edit-webhook': ModalActionEditWebhook,
        'v-modal-action-edit-zapier': ModalActionEditZapier,
        'v-modal-action-test-email': ModalActionTestEmail,
        'v-modal-action-test-webhook': ModalActionTestWebhook,
    },

    props: {
        action: {
            type: Object,
        },
    },

}

</script>
